import { service } from '../index.js'

// 开屏广告管理
export const splashAd = {
  // 列表（后台）
  list: ({ params = {} } = {}) => {
    return service.get('/splash-ad/admin/list', { params })
  },

  // 添加
  add: (data) => {
    return service.post('/splash-ad/admin/save', data)
  },

  // 更新
  update: (data) => {
    return service.post('/splash-ad/admin/save', data)
  },

  // 切换状态
  toggleStatus: (data) => {
    return service.post('/splash-ad/admin/toggle-status', data)
  },

  // 删除
  delete: (params) => {
    return service.post('/splash-ad/admin/delete', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/splash_ad.js